import React, { useState } from 'react';
import {
  Button,
  TableCell,
  TableRow
} from '@material-ui/core';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { format } from 'date-fns';
import ErrorDialog from './ErrorDialog';


const statusColors = {
  InProgress: '#103A99',
  Completed: '#008000',
  Failed: '#FF0000',
};

const RPATableRow = ({ syncLog }) => {
  const [isOpenDialog, setOpenDialog] = useState(false);

  const startedAt = convertUTCDateToLocalDate(syncLog.started_at);
  const endedAt = convertUTCDateToLocalDate(syncLog.ended_at);
  const statusColor = statusColors[syncLog.status];

  return (
    <TableRow>
      <TableCell className="pl-sm-24 w-130 font-bold">
        {syncLog.event_name}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center">
        {format(startedAt, 'MM/dd/yyyy hh:mm:ss aa')}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center">
        {format(endedAt, 'MM/dd/yyyy hh:mm:ss aa')}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center" style={{color: statusColor}}>
        {syncLog.status}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center">
        {syncLog.records_created}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center">
        {syncLog.records_updated}
      </TableCell>
      <TableCell className="px-0 font-bold w-100" align="center">
        {syncLog.error &&
          <Button
            variant="outlined"
            className="p-0"
            color="primary"
            onClick={() => setOpenDialog(true)}
          >
            ERROR
          </Button>
        }
      </TableCell>
      <ErrorDialog
        error={syncLog.error}
        isOpenDialog={isOpenDialog}
        setOpenDialog={setOpenDialog}
      />
    </TableRow>
  );
};

export default RPATableRow;
